import React, { useEffect, useState } from 'react'

import { Button, Card, Form, Row, Typography, Icon, notification } from 'antd'
import { Formik } from 'formik'

import { MATERIAL_VALIDATION_SCHEMA } from './MaterialValidation'
import { RULES, validRule } from '../../constants/Entitlements'
import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { getMessage } from '../../util/IntlMessages'
import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import CustomInput from '../../components/CustomInput/customInput'
import { api, request } from '../../util/handlerRequestUtil'
import CustomSelect from '../../components/CustomSelect/customSelect'

const CreateMaterials = ({ match, history }) => {
  const [brands, setBrands] = useState([])
  const [technologies, setTechnologies] = useState([])
  const [material, setMaterial] = useState({ active: true })
  const { id } = match.params

  useEffect(() => {
    fetchBrands()
    fetchTechnologies()
    if (id) {
      fetchMaterial(id)
    }
  }, [id])

  async function fetchBrands() {
    const items = await request(api.getBrandsDropDown({ active: true, todos: false }))
    setBrands(items)
  }

  async function fetchTechnologies() {
    const items = await request(api.getTechnologiesDropDown({ todos: false }))
    setTechnologies(items)
  }

  async function fetchMaterial(id) {
    const material = await request(api.getOneMaterial(id))
    setMaterial(material)
  }

  async function createMaterial(payload) {
    await request(api.createMaterial(payload))
    notification.success({
      description: getMessage('successStoreMaterial'),
      message: getMessage('sweetAlerts.success')
    })
  }

  async function updateMaterial(payload) {
    await request(api.updateMaterial(payload))
    notification.success({
      description: getMessage('successUpdateMaterial'),
      message: getMessage('sweetAlerts.success')
    })
  }

  async function onSubmit(values) {
    const payload = {
      name: values.name,
      brandId: Number(values.brandId),
      tecnologiaId: Number(values.tecnologiaId),
      active: values.active,
      maturationGroup: Number(values.maturationGroup)
    }

    if (!id) {
      await createMaterial(payload)
    } else {
      await updateMaterial({ id, ...payload })
    }

    history.goBack()
  }

  function renderHeader(submitForm) {
    const hasAccess = id === undefined ? validRule(RULES.MATERIAL) : validRule(RULES.MATERIAL)

    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <div className="default-header-buttons">
            <Button className="button-return" onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button type="primary" className="button-action" onClick={submitForm}>
                {id !== undefined ? getMessage('update') : getMessage('register')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  function renderTitle() {
    return id !== undefined ? getMessage('updateMaterials') : getMessage('createMaterials')
  }

  return (
    <Formik
      enableReinitialize
      initialValues={material}
      validationSchema={MATERIAL_VALIDATION_SCHEMA}
      onSubmit={onSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ values, errors, submitForm, handleSubmit, handleBlur, setFieldValue }) => (
        <Form layout="vertical" onSubmit={handleSubmit}>
          {renderHeader(submitForm)}

          <Card className="ant-card gx-card ant-card-bordered">
            <Typography.Title className="default-header-title" level={3}>
              {renderTitle()}
            </Typography.Title>

            <Row type="flex" justify="start">
              <CustomSwitch
                field="active"
                errors={errors}
                setFieldValue={setFieldValue}
                rowSpan={12}
                value={values}
                handleBlur={handleBlur}
                unCheckedChildren={getMessage('label.inactive')}
                checkedChildren={getMessage('label.active')}
              />
            </Row>
            <Row type="flex" justify="start">
              <CustomInput
                field="name"
                errors={errors}
                placeholder="Nome do Material"
                setFieldValue={setFieldValue}
                rowSpan={10}
                value={values}
                handleBlur={handleBlur}
              />
              <CustomSelect
                showSearch
                field="brandId"
                errors={errors}
                setFieldValue={setFieldValue}
                rowSpan={5}
                value={values}
                values={brands}
                required
              />
              <CustomSelect
                showSearch
                field="tecnologiaId"
                errors={errors}
                setFieldValue={setFieldValue}
                rowSpan={5}
                value={values}
                values={technologies}
                required
              />
              <CustomInput
                field="maturationGroup"
                errors={errors}
                placeholder="Grupo de Maturação"
                setFieldValue={setFieldValue}
                rowSpan={10}
                value={values}
                handleBlur={handleBlur}
              />
            </Row>
          </Card>
        </Form>
      )}
    </Formik>
  )
}

export default CreateMaterials
